import * as BeerSlider from 'beerslider';

class CardAvantApres {
  constructor() {
    this._init();
  }

  _init() {
    const cards = document.querySelectorAll('.card-avant-apres__images');
    const options = {
      start: '80',
    };
    cards.forEach(card => {
      new BeerSlider(card as HTMLElement, options);
    });
  }

}

export const cardAvantApres = new CardAvantApres();
